import { Directive, HostListener } from '@angular/core';

// Só detecta ao digitar: o navegador não informa o Caps Lock antes da primeira tecla.
@Directive({
  selector: '[appCapsLockWarning]',
  exportAs: 'capsLockWarning'
})
export class CapsLockWarningDirective {

  ativo = false;

  @HostListener('keydown', ['$event'])
  @HostListener('keyup', ['$event'])
  onKey(event: KeyboardEvent): void {
    this.ativo = !!event.getModifierState?.('CapsLock');
  }

  @HostListener('blur')
  onBlur(): void {
    this.ativo = false;
  }
}
